import { render } from "./EdmViewFullKit.vue?vue&type=template&id=a285696e"
import script from "./EdmViewFullKit.vue?vue&type=script&lang=js"
export * from "./EdmViewFullKit.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__